import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OverlayRoutingModule } from "./overlay-routing.module";
import { ReviewParsedCvDialogModule } from "./review-parsed-cv-dialog/review-parsed-cv-dialog.module";

@NgModule({
  imports: [CommonModule, OverlayRoutingModule, ReviewParsedCvDialogModule],
})
export class OverlayModule {}
